/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';

interface EvidenceLinkProps {
  link: string;
}

export const EvidenceLink = (props: EvidenceLinkProps) => {
  const { link } = props;

  if (typeof link === 'string' && link.startsWith('http')) {
    return (
      <a href={link} target={'_blank'} rel='noopener noreferrer'>
        {link}
      </a>
    );
  }

  return link;
};
